import React from "react";
import {Card} from "antd";

export function TermsCard() {
    return <Card>
        Products sold at Whole Foods Market must comply with our ingredient standards. For more information visit <a href="https://innerview.wholefoods.com/pages/quality-standards-sustainability/ingredient/">Ingredient
        Standards and Policies on Innerview</a> or contact the Quality Standards team at Quality.Standards@wholefoods.com.
    </Card>
}